import React, { LabelHTMLAttributes } from 'react';

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  text: string;
}

const Label: React.FC<LabelProps> = ({ text, ...restProps }) => {
  return (
    <label
      className="text-md uppercase flex mb-2 font-bold text-primary-800"
      {...restProps}
    >
      {text}
    </label>
  );
};

export default Label;
